import React from 'react';
const LogicSvg = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      className={className}
      {...props}
    >
      <rect
        x="0.492188"
        width="27.9964"
        height="28"
        rx="13.9982"
        fill={color}
      />
      <path
        d="M8.52697 21H11.6913C12.2667 21 12.7266 20.54 12.7266 19.9647L12.7274 17.5674C12.7274 16.9921 12.2674 16.5321 11.6921 16.5321H10.3114V15.5155C10.3114 15.2856 10.5991 15.0743 10.925 15.0743H17.9445C18.2898 15.0743 18.558 15.2661 18.558 15.5155V16.5321H17.2538C16.6784 16.5321 16.2185 16.9921 16.2185 17.5674V19.9647C16.2185 20.54 16.6784 21 17.2538 21H20.4181C20.9935 21 21.4534 20.54 21.4534 19.9647V17.5674C21.4534 16.9921 20.9935 16.5321 20.4181 16.5321H19.1139V15.5155C19.1139 14.9597 18.5767 14.499 17.925 14.499H14.7411V13.1565C16.333 13.0224 17.5796 11.6987 17.5796 10.088C17.5796 8.3815 16.1989 7 14.4916 7C12.785 7 11.4035 8.38066 11.4035 10.088C11.4035 11.68 12.6119 12.9843 14.1648 13.1565V14.5184L10.9435 14.5177C10.2917 14.5177 9.75457 14.9777 9.75457 15.5343V16.5509H8.52749C7.95215 16.5509 7.49219 17.0108 7.49219 17.5862V19.9834C7.49144 20.54 7.9514 21 8.52674 21L8.52697 21Z"
        fill="white"
      />
    </svg>
  );
};

export default LogicSvg;
